<template>
	<div class="one">
		<div class="top">
			<div class="category">
				<div v-for="(item,index) in category" :class="'item '+(categoryIndex == index? 'selected':'')"
					:key="index" @click="categoryChange(index)">
					<i class="el-icon-location" v-show="categoryIndex == index"></i>
					{{item.name}}
				</div>
			</div>
		</div>
		<div class="list">
			<div class="fixation">
				<div class="commodity-block" v-if="list.length > 0">
					<commodity v-for="(item,index) in list" :key="index" :node="item"></commodity>
				</div>
				<div class="commodity-block" v-else>
					<div class="empty">
						<el-empty></el-empty>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'one',
		data() {
			return {
				category: [],
				categoryIndex: 0,
				list: [],
				currentPage: 1
			};
		},
		methods: {
			fetchCategory() {
				this.$api.frontCategory({}, res => {
					if (res.code == 200) {
						let list = res.data
						let array = new Array()
						for (let i = 0; i < list.length; i++) {
							let obj = {
								name: list[i]['name'],
								id: list[i]['id']
							}
							array.push(obj)
						}
						this.category = array
						this.fetchList()
					}
				})
			},
			fetchList() {
				this.$api.frontCommodityList({
					activityId: 3,
					pageNum: this.currentPage,
					pageSize: 16,
					lotOneType: this.category[this.categoryIndex]['id']
				}, res => {
					if (res.code == 200) {
						let list = res.data.list
						let array = new Array()
						for (let i = 0; i < list.length; i++) {
							let transTime = ''
							if (list[i].auctionStatus == 1) {
								transTime = list[i]['startTime']
							} else {
								transTime = list[i]['endTime']
							}
							let diff = this.$pub.timeStampDifferene(transTime)
							let obj = {
								image: list[i]['lotPictrueUrl'],
								name: list[i]['lotName'],
								now: !list[i]['currentPrice'] ? list[i]['startPrice'] : list[i][
									'currentPrice'
								],
								number: !list[i]['biddingCount'] ? 0 : list[i][
									'biddingCount'
								],
								evaluated: list[i]['evaluationPrice'],
								day: diff.day,
								timeStr: diff.h+':'+diff.m+':'+diff.s,
								view: !list[i]['watchFrequency'] ? 0 : list[i][
									'watchFrequency'
								],
								people: !list[i]['enrollNumber'] ? 0 : list[i][
									'enrollNumber'
								],
								status: list[i]['auctionStatus'],
								id: list[i]['id'],
							}
							array.push(obj)
						}
						if (this.currentPage == 1) {
							this.list = array
						} else {
							this.list = this.list.concat(array)
						}
						this.totalPage = Math.ceil(res.data.total / 16)
					}
				})
			},
			categoryChange(index) {
				this.currentPage = 1
				this.categoryIndex = index
				this.fetchList()
			},
			pageScroll() {
				if (this.currentPage == this.totalPage) {
					return
				}
				let scrollTop = document.documentElement.scrollTop
				let scrollHeight = document.documentElement.scrollHeight
				let clientHeight = document.documentElement.clientHeight
				if (scrollTop + clientHeight - scrollHeight >= 0) {
					console.log("页面到底");
					this.currentPage++;
					//滚动至底部后请求数据
					this.fetchList();
				}
			}
		},
		beforeCreate: function() {
			//生命周期 -- 组件实例刚被创建，组件属性计算之前，如DATA属性等
		},
		created: function() {
			//生命周期 -- 组件实例创建完成，属性已绑定，但DOM还未生成，$el属性还不存在
		},
		beforeMount: function() {
			//模板编译/挂载之前
		},
		mounted: function() {
			//模板编译/挂载之后
			this.fetchCategory()
			window.onscroll = this.pageScroll
		},
		beforeUpdate: function() {
			//组件更新之前
		},
		updated: function() {
			//组件更新之后
		},
		activated: function() {
			// for keep-alive，组件被激活时调用
		},
		deactivated: function() {
			// for keep-alive，组件被移除时调用
		},
		beforeDestory: function() {
			// 组件销毁调用
		},
		destoryed: function() {
			// 组件销毁后调用
		}
	};
</script>

<style lang="less" scoped="scoped">
	.top {
		width: 100%;
		height: 680px;
		background: url(../../../assets/one-top-2.jpg) no-repeat;
		background-size: 100% 100%;
		display: flex;
		align-items: flex-end;
		justify-content: center;

		.category {
			width: 1200px;
			height: 50px;
			display: flex;
			align-items: center;
			background: @vue-bg-color;
			border-radius: @vue-border-radius-lg;
			overflow: hidden;

			.item {
				height: 100%;
				padding: 0px @vue-spacing-row-lg;
				box-sizing: border-box;
				display: flex;
				align-items: center;
				cursor: pointer;
				font-size: @vue-font-size-sm - 2;

				i {
					margin-right: @vue-spacing-row-sm / 2;
					font-size: @vue-font-size-sm + 2;
				}
			}

			.selected {
				background: linear-gradient(#E0E0E0, #F9F9F9);
				color: @vue-text-color-red;
			}
		}
	}

	.list {
		width: 100%;
		background: #9e120c;
		position: relative;
		top: -1px;
		padding: @vue-spacing-col-lg 0px;

		.commodity-block {
			margin-top: @vue-spacing-col-lg;

			.empty {
				width: 100%;
				height: 400px;
				background: @vue-bg-color;
				display: flex;
				justify-content: center;
				align-items: center;
				margin-bottom: @vue-spacing-col-lg;
			}
		}
	}
</style>
